import { createSelector } from "reselect";
import { isWebDesktop } from "./../../utils/deviceDetectors";
import { AppState } from "../rootReducer";
import { getUserId } from "../user/selectors";

export const getRankingRequesting = (state: AppState) =>
  state.ranking.requesting;

export const getRankingLoading = (state: AppState) => state.ranking.loading;

export const getUserRankings = (state: AppState) => state.ranking.userRanking;

export const getRankingHasResult = (state: AppState) => state.ranking.hasResult;

export const getRankingUserRankingPage = (state: AppState) =>
  state.ranking.userRankingPage;

export const getTeamRankingPage = (state: AppState) =>
  state.ranking.campaignTeamRankingPage;

export const getRankingUserRanking = (state: AppState) =>
  state.ranking.userRanking;

export const getUserRank = createSelector(
  getUserRankings,
  getUserId,
  (userRankings, userId) => {
    const index = userRankings.findIndex(user => user._id === userId);
    return index + 1;
  },
);

export const getCampaignTeamRanking = (state: AppState) => state.ranking.campaignTeamRanking;

const numberOfRank = isWebDesktop ? 10 : 3;
export const getFirstUserRankings = createSelector(
  getUserRankings,
  userRankings => {
    return userRankings.slice(0, numberOfRank);
  },
);

export const getFirstTeamRankings = createSelector(
  getCampaignTeamRanking,
  campaignTeamRanking => {
    return campaignTeamRanking.slice(0, 3) || [];
  },
);
